var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toMoney, toPercentage, toDateTime } from 'helpers/Format';
import Report from '../components/Report';
let Sales = class Sales extends Component {
    componentDidMount() {
        this.props.store.reports.readInvoices();
    }
    render() {
        const { reports } = this.props.store;
        const headers = this.props.store.UI.isDesktop
            ? ['number', 'date', 'netAmount', 'discount', 'taxAmount', 'total']
            : ['number', 'date', 'total'];
        const items = reports.invoices;
        return (React.createElement(Report, { header: headers, items: items, total: (invoices) => invoices.reduce((sum, item) => item.total + sum, 0), loading: !reports.invoicesLoaded, keyExtractor: (invoice) => String(invoice.id), format: (invoices) => invoices.map(invoice => (Object.assign(Object.assign({}, invoice), { date: toDateTime(invoice.date), discount: toPercentage(invoice.discount), netAmount: toMoney(invoice.netAmount), taxAmount: toMoney(invoice.taxAmount), taxBase: toMoney(invoice.taxBase), total: toMoney(invoice.total) }))) }));
    }
};
Sales = __decorate([
    inject('store'),
    observer
], Sales);
export default Sales;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/Sales.tsx
// module id = 500
// module chunks = 0